import { CardOrientationQueryParam } from "../../CardOrientation/constants";
import { DEFAULT_PAGE, PAGE_QUERY_PARAM } from "../../state/products/items/constants";

type GetCanonicalUrl = (
  hostname: string,
  currentPath: string,
  validFilters: Array<Array<string>>,
  currentFilters: Array<string>
) => string;
export const getCanonicalUrl: GetCanonicalUrl = (
  hostname,
  currentPath,
  validFilters,
  currentFilters
) => {
  const canonicalUrl = new URL(currentPath, hostname);

  // remove card orientation param
  canonicalUrl.searchParams.delete(CardOrientationQueryParam);

  // remove default page param
  if (canonicalUrl.searchParams.get(PAGE_QUERY_PARAM) === DEFAULT_PAGE.toString()) {
    canonicalUrl.searchParams.delete(PAGE_QUERY_PARAM);
  }
  // remove non-existent secondary filter params
  const validFiltersList = validFilters.reduce(
    (accumulator, value) => accumulator.concat(value),
    []
  );
  currentFilters.forEach((filter: string) => {
    if (!validFiltersList.includes(filter)) {
      canonicalUrl.searchParams.delete(filter.split("=")[0]);
    }
  });
  return canonicalUrl.toString();
};
